<link rel="alternate" type="application/rss+xml" title="RSS 2.0" href="https://uni.xyz/competitions/rss/" />
<div class="bottom-margin">
  <uni-search 
    [showOptions]="false"
    placeholder="Search Competitions on UNI"
    (searchedText)="goToSearchPage($event)">
  </uni-search>
</div>

<ng-container *ngIf="isLoading; else viewCompetitionSections">
  <div class="margin-top-3 sparro-bg-white border-radius-3 padding-y-3 padding-x-1">
    <uni-skeleton-loader
      appearance="competition"
      [count]="limit" [alignCenter]="true">
    </uni-skeleton-loader>
  </div>
</ng-container>
<ng-template #viewCompetitionSections>
  <div class="competition-sections-wrapper">
    <ng-container *ngFor="let section of competitionSections;let i=index; let last=last">
      <div class="width-100 sparro-bg-white border-radius-3 padding-y-3 padding-x-1 bottom-margin" fxLayout="column">
        <h2 class="section-title font-md font-bold sparro-grey-900 text-center">{{ section.title }}</h2>
        <h3 class="section-desc margin-x-auto font-sm font-regular sparro-grey-800 text-center" [innerHTML]="section.description | safeContent"></h3>
  
        <uni-competition-cards-group
          [competitions]="section.visible_competitions"
          [display]="section.display"
          [host]="host"
          align="center">
        </uni-competition-cards-group>
        <div class="width-100 margin-top-8 card-btn" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
          <uni-state-button
            default="Load more"
            button_class="secondary"
            (click)="loadMore(section)"
            *ngIf="section.competitions.length >= limit || section.competitions.length !== section.visible_competitions.length">
          </uni-state-button>
          <a [href]="getSectionUrl(section.slug)">
            <uni-navigation-button
              default="Show all"
              button_class="secondary">
            </uni-navigation-button>
          </a>
        </div>
      </div>
      <div class="bottom-margin" *ngIf="adsArray.length && (i+1)%5==0">
        <uni-advertisement-card [advertisement]="adsArray[(i+5)%adsArray.length]"></uni-advertisement-card>
      </div>
    </ng-container>

    <ng-container *ngIf="competitions && competitions.length > 0 && allSectionsLoaded">
      <ng-container *ngFor="let competitionSection of competitions; let first=first; let i=index;">
        <div *ngIf="competitionSection.length > 0"
          class="sparro-bg-white border-radius-3 padding-y-3 padding-x-1 bottom-margin">
          <div class="latest-comp-wrapper " *ngIf="first">
            <div class="all-sections-loaded-wrapper">
              <h2 class="section-title font-md font-bold sparro-grey-900 text-center">Current and upcoming challenges</h2>
              <h3 class="section-desc margin-x-auto font-sm font-regular sparro-grey-800 text-center">Recently launched competitions</h3>
            </div>
            <div class="padding-x-2 previous-btn-wrapper justify-content-end">
              <uni-navigation-button
                default="See previous competitions"
                button_class="primary"
                (click)="goToPreviousComp()">
              </uni-navigation-button>
            </div>
          </div>
    
          <div class="competitions-cards-wrapper" fxLayout="row" fxLayoutAlign="center center">
            <uni-competition-cards-group
              [competitions]="competitionSection"
              [display]="display"
              [host]="host"
              align="center">
            </uni-competition-cards-group>
          </div>
        </div>
        <div class="bottom-margin" *ngIf="adsArray.length">
          <uni-advertisement-card [advertisement]="adsArray[i%adsArray.length]"></uni-advertisement-card>
        </div>
      </ng-container>
    </ng-container>

    <uni-state-button
      default="Load More"
      button_class="secondary"
      (click)="loadCompetitions()"
      [hidden]="isLoading || showSpinner || !(next || !allSectionsLoaded)">
    </uni-state-button>

    <div class="loaderSection" fxLayout="row" fxLayoutAlign="center center" *ngIf="showSpinner">
      <uni-loader></uni-loader>
    </div>
  </div>
</ng-template>
<uni-public-footer [seoContent]="seoContent"></uni-public-footer>